export const ASSETS_API_BASE_URL = 'https://assets-worker.khanhthinh-45a4.workers.dev'
export const STOCK_PRICES_API_BASE_URL = 'https://stock-prices-worker.khanhthinh-45a4.workers.dev'

export const ENDPOINTS = {
  // Portfolios
  portfolios: '/v1/portfolios',
  portfolio: (id: number) => `/v1/portfolios/${id}`,
  portfolioShares: (id: number) => `/v1/portfolios/${id}/shares`,
  portfolioShare: (id: number, userId: string) => `/v1/portfolios/${id}/shares/${userId}`,
  portfolioTransfer: (id: number) => `/v1/portfolios/${id}/transfer`,
  sharedWithMe: '/v1/portfolio-shares/shared-with-me',

  // Assets
  assets: '/v1/assets',
  asset: (id: number) => `/v1/assets/${id}`,
  assetTransactions: (id: number) => `/v1/assets/${id}/transactions`,
  assetRecalculate: (id: number) => `/v1/assets/${id}/recalculate`,
  assetsRecalculateAll: '/v1/assets/recalculate-all',
  assetHistory: (id: number) => `/v1/assets/${id}/history`,

  // Asset Groups
  assetGroups: '/v1/asset-groups',
  assetGroup: (id: number) => `/v1/asset-groups/${id}`,
  assetGroupHistory: (id: number) => `/v1/asset-groups/${id}/history`,

  // Portfolio History
  portfolioHistory: (id: number) => `/v1/portfolios/${id}/history`,

  // Transactions
  transactions: '/v1/transactions',
  transaction: (id: number) => `/v1/transactions/${id}`,
  transactionsByRef: (refId: string) => `/v1/transactions/ref/${refId}`,

  // Stock Prices
  stockPrices: '/v1/stock-prices',
  stockPriceHistory: '/v1/stock-prices/history',

  // Crypto Prices
  cryptoPrices: '/v1/crypto-prices',

  // FX Rates
  fxRates: '/v1/fx-rates',
} as const
